// extracted by mini-css-extract-plugin
export default {"card":"styles_card__qKUH8","message":"styles_message__9RPhv"};